module.exports = __webpack_public_path__ + "6e707fb38e92f39af9958d6be97a74b0.pdf";